import LinkA11yWrapper, { LinkA11yWrapperProps } from 'components/helpers/LinkA11yWrapper';
import { NavigationLink, NavPageOrLink, GenericPage } from './_types';
import { pageNavigationDataLayerHandler } from 'lib/util/gtm-datalayer';
import { isNavigationLink, isGenericPage } from './_guards';
import { logWarning } from 'lib/util/errors';

export const LinkForNavigationLink = ({
  item,
  ...props
}: Omit<LinkA11yWrapperProps, 'field'> & { item: NavigationLink }): JSX.Element => {
  return (
    <LinkA11yWrapper
      editable={false}
      id={`nav-links--${item.id}`}
      onGtmPush={pageNavigationDataLayerHandler}
      {...props}
      field={item.fields.navigationItemLink}
    />
  );
};
export const LinkForGenericPage = ({
  item,
  ...props
}: Omit<LinkA11yWrapperProps, 'field'> & { item: GenericPage }): JSX.Element => {
  return (
    <LinkA11yWrapper
      editable={false}
      id={`nav-links--${item.id}`}
      onGtmPush={pageNavigationDataLayerHandler}
      {...props}
      field={{
        value: {
          href: item.url,
          text:
            item.fields.navigationTitle?.value ??
            item.fields.pageTitle?.value ??
            item.displayName ??
            item.name,
        },
      }}
    />
  );
};
export const LinkForNavPageOrLink = ({
  item,
  ...props
}: Omit<LinkA11yWrapperProps, 'field'> & { item: NavPageOrLink }): JSX.Element => {
  if (isNavigationLink(item)) {
    return <LinkForNavigationLink item={item} {...props} />;
  }
  if (isGenericPage(item)) {
    return <LinkForGenericPage item={item} {...props} />;
  }
  // should never happen
  logWarning('LinkForNavPageOrLink: item is neither NavigationLink nor GenericPage', item);
  return <></>;
};
